import { Button } from '@cointracker/styleguide/src/LoggedIn/Button';
import { TextAndImage } from '@cointracker/styleguide/src/TextAndImage';
import { H6 } from '@cointracker/styleguide/src/typography';
import classNames from 'classnames';
import { forwardRef, type Ref } from 'react';
import questionImageURL from '../images/question.webp?url';
import { buttons, content, textAndImage } from './QuestionBlock.css';

export interface QuizFlowQuestion {
  text: string;
  answers: string[];
  skippable?: boolean;
}

export interface QuestionBlockProps {
  className?: string;
  onAnswer?: (answerIndex: number | null) => void;
  question: QuizFlowQuestion;
}

export const QuestionBlock = forwardRef(
  (
    { className, onAnswer, question, ...rest }: QuestionBlockProps,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <TextAndImage
        className={classNames(className, textAndImage)}
        ref={ref}
        desktopImageOnly
        imgSrc={questionImageURL}
        imgAlt="question"
        {...rest}
      >
        <div className={content}>
          <H6>{question.text}</H6>
          <div className={buttons}>
            {question.answers.map((answer, i) => (
              <Button
                key={i}
                fluid
                variant="line"
                onClick={() => onAnswer?.(i)}
              >
                {answer}
              </Button>
            ))}
            {question.skippable && (
              <Button transparent fluid onClick={() => onAnswer?.(null)}>
                Skip this question
              </Button>
            )}
          </div>
        </div>
      </TextAndImage>
    );
  },
);

QuestionBlock.displayName = 'QuestionBlock';
